var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncorrectAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.412109C6.28017 0.412109 0 6.69228 0 14.4121C0 22.1319 6.28017 28.4121 14 28.4121C21.7198 28.4121 28 22.1319 28 14.4121C28 6.69228 21.7198 0.412109 14 0.412109ZM18.3248 17.0873C18.781 17.5434 18.781 18.2808 18.3248 18.7369C18.0973 18.9644 17.7987 19.0788 17.5 19.0788C17.2013 19.0788 16.9027 18.9644 16.6752 18.7369L14 16.0618L11.3248 18.7369C11.0973 18.9644 10.7987 19.0788 10.5 19.0788C10.2013 19.0788 9.90267 18.9644 9.67517 18.7369C9.219 18.2808 9.219 17.5434 9.67517 17.0873L12.3503 14.4121L9.67517 11.7369C9.219 11.2808 9.219 10.5434 9.67517 10.0873C10.1313 9.63111 10.8687 9.63111 11.3248 10.0873L14 12.7624L16.6752 10.0873C17.1313 9.63111 17.8687 9.63111 18.3248 10.0873C18.781 10.5434 18.781 11.2808 18.3248 11.7369L15.6497 14.4121L18.3248 17.0873Z",
    fill: "#EE4E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrectAnswer);
export default __webpack_public_path__ + "static/media/incorrectAnswer.274c45b7f9701cf14ca1ed73fe6512dd.svg";
export { ForwardRef as ReactComponent };